import React from "react";
import { AlertTriangle, Network, Users, FileWarning, TrendingDown, Receipt } from "lucide-react";
import { useLocale } from "../../i18n/LocaleContext";

export default function Problem() {
  const { t } = useLocale();
  const TILES = [
    { icon: Network, title: t("landing.problem.tile1.title"), body: t("landing.problem.tile1.body"), span: "md:col-span-2", accent: true },
    { icon: Users, title: t("landing.problem.tile2.title"), body: t("landing.problem.tile2.body") },
    { icon: TrendingDown, title: t("landing.problem.tile3.title"), body: t("landing.problem.tile3.body") },
    { icon: AlertTriangle, title: t("landing.problem.tile4.title"), body: t("landing.problem.tile4.body"), span: "md:col-span-2" },
    { icon: FileWarning, title: t("landing.problem.tile5.title"), body: t("landing.problem.tile5.body") },
    { icon: Receipt, title: t("landing.problem.tile6.title"), body: t("landing.problem.tile6.body") },
  ];
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="bg-slate-950 text-white py-24 md:py-32 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-dark opacity-30 -z-0" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] text-slate-400 font-semibold mb-4">
            <span className="inline-block h-px w-8 bg-white/20" />
            <span>{t("landing.problem.eyebrow")}</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl xl:text-[56px] font-semibold tracking-[-0.02em] mt-1 leading-[1.05]">
            {t("landing.problem.headline")}
          </h2>
          <p className="mt-5 text-slate-300/90 text-lg leading-relaxed font-light">
            {t("landing.problem.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {TILES.map((tile, i) => (
            <div
              key={tile.title}
              data-testid={`problem-tile-${i}`}
              className={`group rounded-xl border border-white/10 bg-gradient-to-b ${
                tile.accent ? "from-[#0072CE]/20 to-slate-900/40" : "from-white/[0.04] to-white/[0.02]"
              } p-7 hover:border-[#0072CE]/60 transition-colors ${tile.span || ""}`}
            >
              <div className="h-11 w-11 rounded-lg bg-white/10 border border-white/10 flex items-center justify-center text-[#7DD3FC] mb-5">
                <tile.icon size={20} />
              </div>
              <h3 className="font-display text-xl font-semibold tracking-tight">
                {tile.title}
              </h3>
              <p className="mt-2 text-slate-300/85 leading-relaxed text-sm md:text-base">
                {tile.body}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-xl border border-white/10 bg-white/[0.03] p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-slate-200 md:text-lg max-w-3xl">
            <span className="text-white font-semibold">{t("landing.problem.bottom_line")} </span>
            {t("landing.problem.bottom_body")}
          </p>
          <span
            data-testid="problem-stat-callout"
            className="text-3xl font-display font-bold text-[#7DD3FC]"
          >
            {t("landing.problem.callout")}
          </span>
        </div>
      </div>
    </section>
  );
}
